import { styled } from '@cherre-frontend/ui';

export const SourceCustomFormContainer = styled('div')`
  border-radius: 5px;
  background: #eee;
  padding: 30px;
  grid-template-columns: 1fr;
`;

export const FormContainer = styled('div')`
  grid-template-columns: 1fr 1fr;
  display: grid;
`;
